import { render, staticRenderFns } from "./RecentPageItem.vue?vue&type=template&id=de44afa4&"
import script from "./RecentPageItem.vue?vue&type=script&lang=js&"
export * from "./RecentPageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports